import type { ApiError } from '@/hooks/useApi';

type Translate = (key: string, options?: Record<string, unknown>) => string;

const MISSING = '\u0000missing\u0000';

/**
 * Words a refusal that is not Pro's: the server's own key when this build
 * has it (a rate limit, a validation error), the generic line otherwise.
 */
export function proFallbackMessage(error: ApiError, t: Translate): string {
  const key = error.translationKey;
  if (key) {
    const details =
      error.details && typeof error.details === 'object'
        ? (error.details as Record<string, unknown>)
        : {};
    const text = t(key, { ...details, defaultValue: MISSING });
    if (text !== MISSING) return text;
  }
  return t('errors:api.status.default');
}
